import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import React from 'react';
import './GenericHeaderAndContent.scss';

export interface GenericHeaderAndContentInputs {
    title?: string;
    body?: string;
    largeTitle?: boolean;
    largeText?: boolean;
    mediumLargeTitle?: boolean;
    standalone?: boolean;
    background?: boolean;
    image?: any;
    imageAlt?: any;
    smallBackground?: string;
    h1?: boolean;
    turnLinkIntoButton?: boolean;
    skinny?: boolean;
}

export const GenericHeaderAndContent = ({
    inputs,
}: {
    inputs: GenericHeaderAndContentInputs;
}) => {
    let body = inputs.body;
    if (body && inputs.turnLinkIntoButton) {
        body = body.replaceAll(
            `<a `,
            `<a class="kite-button kite-button--primary kite-button--lg kite-button--shrinkwrap" `
        );
    }
    return (
        <div className={inputs.background ? `generic__bg` : undefined}>
            <section
                className={`kite-container paragraph__generic_content ${
                    inputs.smallBackground ? `bg-${inputs.smallBackground}` : ``
                } ${inputs.skinny ? `skinny` : ``}`}
            >
                {!!inputs.title && (
                    <>
                        {!inputs.h1 && (
                            <h2
                                className={
                                    inputs.largeTitle
                                        ? `typestack-title-1`
                                        : inputs.mediumLargeTitle
                                        ? `typestack-title-2`
                                        : `typestack-title-3`
                                }
                            >
                                {inputs.title}
                            </h2>
                        )}
                        {inputs.h1 && <h1>{inputs.title}</h1>}
                    </>
                )}
                {!!body && (
                    <div
                        className={`${inputs.largeText ? `large` : ``} ${
                            inputs.standalone ? `standalone` : ``
                        }`}
                        dangerouslySetInnerHTML={{ __html: body }}
                    ></div>
                )}
                {!!inputs.image && (
                    <GatsbyImage
                        image={getImage(inputs.image)}
                        alt={inputs.imageAlt}
                    />
                )}
            </section>
        </div>
    );
};
